var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isStockAdmin)?_c('div',[_c('DailyReport',{attrs:{"isStock":true}})],1):_c('div',[_c('CustomerCount'),(_vm.isDailyReport)?_c('DailyReport',{attrs:{"isStock":false}}):_vm._e(),_c('TotalAgencies'),_c('CustomerSource')],1)}
var staticRenderFns = []

export { render, staticRenderFns }